<template>
	<div class="tab-container">
		<div class="tab-content">
			<h1>진담헤어 고객용 이용약관</h1>
			<br />

			<section>
				<h2>제1조 (목적)</h2>
				<p>
					이 약관은 진담헤어(이하 "회사")가 제공하는 모바일 애플리케이션 및 웹 서비스를 통해 제공되는 디자이너 예약 중개 플랫폼(이하 "서비스")의 이용과 관련하여
					회사와 이용자의 권리, 의무 및 책임사항을 규정함을 목적으로 합니다.
				</p>
			</section>

			<section>
				<h2>제2조 (정의)</h2>
				<p>① "회원"이라 함은 본 약관에 동의하고 회사가 제공하는 서비스에 가입하여 이용하는 고객을 말합니다.</p>
				<p>② "디자이너"란 회사와 별도의 계약을 체결하고, 회원에게 미용 관련 서비스를 제공하는 독립사업자를 의미합니다.</p>
				<p>③ "서비스"란 회사가 디자이너와 고객을 연결하여 미용서비스 예약 및 결제 등을 지원하는 온라인 플랫폼 일체를 말합니다.</p>
				<p>④ "예약"이라 함은 회원이 디자이너의 서비스 제공 일정에 따라 시술 요청을 진행하는 절차를 말합니다.</p>
			</section>

			<section>
				<h2>제3조 (약관의 명시 및 변경)</h2>
				<p>① 회사는 본 약관의 내용을 회원이 쉽게 확인할 수 있도록 앱 내 게시하거나 기타 방법으로 고지합니다.</p>
				<p>
					② 회사는 관련 법령에 위배되지 않는 범위에서 본 약관을 개정할 수 있으며, 변경사항은 시행 7일 전까지 공지합니다. 중대한 변경의 경우 최소 30일 전
					고지합니다.
				</p>
				<p>
					③ 변경된 약관은 고지된 시행일로부터 효력을 가지며, 회원이 개정 약관에 동의하지 않을 경우 탈퇴할 수 있습니다. 탈퇴 없이 서비스를 계속 이용하는 경우
					동의한 것으로 간주합니다.
				</p>
			</section>

			<section>
				<h2>제4조 (회원가입 및 관리)</h2>
				<p>① 회원가입은 서비스 내 절차에 따라 본인의 실명 및 필수 정보를 입력하고, 본 약관에 동의함으로써 완료됩니다.</p>
				<p>② 회원은 정확하고 최신의 정보를 제공해야 하며, 허위 또는 타인의 정보를 입력할 경우 회사는 서비스 이용을 제한하거나 탈퇴시킬 수 있습니다.</p>
				<p>③ 회원정보의 변경 시 지체 없이 수정해야 하며, 미수정으로 발생하는 불이익에 대한 책임은 회원에게 있습니다.</p>
			</section>

			<section>
				<h2>제5조 (서비스의 제공)</h2>
				<p>① 디자이너 검색 및 예약 기능</p>
				<p>② 실시간 예약 상태 확인</p>
				<p>③ 결제 서비스 및 예약 내역 관리</p>
				<p>④ 시술 리뷰 작성 기능</p>
				<p>⑤ 고객센터, 알림, 쿠폰, 마케팅 등 부가 서비스</p>
			</section>

			<section>
				<h2>제6조 (예약, 변경 및 취소)</h2>
				<p>① 회원은 디자이너가 등록한 일정과 서비스를 확인한 후 예약을 진행할 수 있습니다.</p>
				<p>② 예약 완료 후 변경 또는 취소는 디자이너의 정책에 따르며, 회사는 이에 관여하지 않습니다.</p>
				<p>③ 노쇼, 반복된 무단취소 등의 경우 회사는 회원의 서비스 이용을 제한할 수 있습니다.</p>
			</section>

			<section>
				<h2>제7조 (결제 및 수수료)</h2>
				<p>① 회원은 서비스 내 제공되는 결제 수단을 통해 사전 또는 현장 결제를 진행할 수 있습니다.</p>
				<p>
					② 결제 시스템은 외부 PG사(예: 이니시스, 토스페이 등)를 통해 운영되며, 결제 오류, 이중결제 등 기술적 문제에 대해서는 해당 PG사가 1차 책임을 집니다.
				</p>
				<p>③ 환불은 디자이너의 환불 정책에 따르며, 회사는 중개자로서 책임을 지지 않습니다.</p>
			</section>

			<section>
				<h2>제8조 (시술사고 및 면책조항)</h2>
				<p>① 회원은 시술 전 디자이너와 충분한 상담을 통해 시술 내용, 제품 성분, 부작용 가능성 등을 확인해야 합니다.</p>
				<p>
					② 고객의 피부 상태, 모발 상태 또는 개인적 특성에 따른 결과 차이, 또는 디자이너의 기술력 차이로 인한 불만족, 부작용 등에 대하여 회사는 책임을 지지
					않습니다.
				</p>
				<p>③ 시술로 인한 모든 법적 책임은 해당 시술을 수행한 디자이너에게 있으며, 고객은 문제 발생 시 해당 디자이너와 직접 해결해야 합니다.</p>
				<p>
					④ 디자이너가 제공한 시술 중 부작용, 신체 손상, 심리적 불만족, 비용 손실 등 민원사항이 발생한 경우, 회사는 법적 책임이나 손해배상 의무를 지지 않으며,
					고객은 해당 디자이너와 직접 해결하여야 합니다.
				</p>
				<p>⑤ 회사는 플랫폼 제공자로서 예약 시스템, 기술적 기능, 중개 절차 외에는 시술 품질, 기술, 위생관리, 결과물 등에 대해 어떠한 보증도 하지 않습니다.</p>
			</section>

			<section>
				<h2>제9조 (리뷰 및 콘텐츠 관리)</h2>
				<p>① 회원은 시술 후 리뷰를 작성할 수 있으며, 이는 공개될 수 있습니다.</p>
				<p>② 다음과 같은 콘텐츠는 사전 통보 없이 삭제되거나 수정될 수 있습니다:</p>
				<ul>
					<li><p>- 허위사실, 명예훼손성 내용</p></li>
					<li><p>- 욕설, 성희롱, 인종/성별 차별 발언</p></li>
					<li><p>- 디자이너의 사생활 침해나 불법 촬영물 포함</p></li>
					<li><p>- 음란성, 불법 광고 또는 타인의 권리를 침해하는 경우</p></li>
				</ul>
			</section>

			<section>
				<h2>제10조 (서비스 이용제한 및 탈퇴)</h2>
				<p>① 회원은 언제든지 앱 내 절차를 통해 탈퇴할 수 있습니다.</p>
				<p>② 다음 각 호에 해당하는 경우 회사는 회원의 서비스 이용을 제한하거나 탈퇴시킬 수 있습니다:</p>
				<ul>
					<li><p>- 다수의 예약 취소 또는 노쇼</p></li>
					<li><p>- 허위 정보 입력 및 명의 도용</p></li>
					<li><p>- 디자이너 또는 회사에 대한 악의적 리뷰 반복</p></li>
					<li><p>- 법령 또는 사회질서에 반하는 행위</p></li>
				</ul>
			</section>

			<section>
				<h2>제11조 (분쟁해결)</h2>
				<p>① 고객과 디자이너 간의 시술 관련 분쟁은 원칙적으로 당사자 간의 협의를 통해 해결합니다.</p>
				<p>② 회사는 중개자로서 분쟁 해결을 위한 자료를 제공하거나 사실 확인을 지원할 수는 있으나, 법적 책임이나 손해배상 의무는 없습니다.</p>
				<p>③ 회사는 분쟁 해결의 공정성을 위해 필요시 고객 또는 디자이너의 리뷰, 예약 기록, 사진 등을 참고자료로 활용할 수 있습니다.</p>
				<p>④ 본 약관과 관련된 분쟁은 회사의 본점 소재지를 관할하는 법원을 제1심 관할법원으로 합니다.</p>
			</section>

			<section>
				<br />
				<br />
				<br />
				<p>- 시행일자: 2025년 8월 8일</p>
				<p>- 버전: 1.0</p>
				<p>- 부칙 : 본 약관은 2025년 8월 8일부터 적용됩니다. 이전 버전의 약관은 본 약관으로 대체됩니다.</p>
			</section>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'TermServiceCustomer',
		data: () => ({}),
	};
</script>

<style scoped>
	.tab-container {
		margin: 20px;
	}

	.tab-content {
		padding: 20px;
		text-align: left;
	}

	h1 {
		font-size: 24px;
	}

	h2 {
		font-size: 20px;
		margin-top: 20px;
	}

	p,
	li {
		font-size: 16px;
		text-indent: 20px;
		list-style: none;
	}

	ul {
		margin-left: 40px;
	}
</style>
